import * as React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { DataProvider } from './Context/Provider';

// client
import Sign from './views/Sign/Sign';
import PasswordReset from './views/Sign/PasswordReset';
import Reconnect from './views/Reconnect';
import Player from './views/player';
import Expired from './views/Expired';
import Payment from './views/Payment';

class App extends React.Component {
  render() {
    return (
      <div className="full">
        {/* <div className="logo-background" /> */}
        <DataProvider>
          <Router basename={process.env.PUBLIC_URL}>
            <Switch>
              <Route exact path="/" component={Sign} />
              <Route exact path="/passwordreset" component={PasswordReset} />
              <Route exact path="/reconnect" component={Reconnect} />
              <Route path="/player" component={Player} />
              <Route path="/expired" component={Expired} />
              <Route path="/pay" component={Expired} />
            </Switch>
          </Router>
        </DataProvider>
      </div>
    );
  }
}

export default App;
